import { pruritusAni } from './intial/flow';

export const PruritusAniFlows = { pruritusAni };
